<template>
  <div class="send_info">
    <el-form ref="form" label-width="80px">
      <el-form-item label="日期：">
        <el-col :span="3">
          <el-date-picker
            v-model="date1"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="日期：">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img
            v-if="share_img"
            :src="share_img"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="寄语：">
        <el-input
          type="textarea"
          v-model="desc"
          placeholder="请输入寄语(最多100个字)"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="出处：">
        <el-input
          type="text"
          v-model="desc2"
          placeholder="请输入出处来源"
          style="width: 300px"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button type="text" id="cancel" @click="open">取消</el-button>
        <!-- <el-button id="cancel">取消</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setcalendarinfo, calendarinfo, calendarupdate } from "@/api/coupon";
  import {
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";
export default {
  data() {
    return {
      name: "",
      region: "",
      date1: "",
      date2: "",
      delivery: false,
      type: [],
      resource: "",
      desc: "", // 寄语
      desc2: "", // 出处
      yeasr: "",
      months: "",
      sendId: null,
      ossAction:'',
      share_img:'',
      query: {
        date: "",
        message: "",
        author: "",
        share_img:''
      },
    };
  },
  mounted() {
    const regex = /id=(\d+)/;
    const match = window.location.href.match(regex);
    const id = match ? match[1] : null;
    // console.log(id);

    this.sendId = id;
    console.log(this.sendId, 22);
    this.searchInfo();
  },
  methods: {
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.query.share_img = fileUrl
          this.share_img = fileUrl
        });
      });
    },
    onSubmit() {
      console.log("submit!", this.yeasr, this.months, this.desc, this.desc2);
      this.query.date = this.date1;
      this.query.message = this.desc;
      this.query.author = this.desc2;
      //   this.$set(this.myObject, 'key', 'value');
      if (this.sendId != null) {
        this.$set(this.query, "id", this.sendId);
        this.searchupdate();
      } else {
        this.searchData();
      }
    },
    searchData() {
      // 创建
      setcalendarinfo(this.query).then((res) => {
        console.log(res);
        // this.tableData = res.data.list;
        if (res.code == 1) {
          this.$router.go(-1);
        } else {
          return;
        }
      });
    },
    searchupdate() {
      //  更新
      calendarupdate(this.query).then((res) => {
        console.log(res);
        // this.tableData = res.data.list;
        if (res.code == 1) {
          this.$router.go(-1);
        } else {
          return;
        }
      });
    },
    searchInfo() {
      // console.log(id);
      let query = {
        id: this.sendId,
      };
      if (this.sendId != null) {
        calendarinfo(query).then((res) => {
          console.log(res.data);
          this.date1 = res.data.date;
          this.desc = res.data.message;
          this.desc2 = res.data.author;
          this.share_img = res.data.share_img
        });
      } else {
        return;
      }
    },
    open() {
      this.$confirm("此操作将删除已填内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "取消成功!",
          });
          this.$router.go(-1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
.el-textarea {
  width: 500px;
  height: 300px;
}
.el-textarea__inner {
  height: 100%;
}
#cancel {
  width: 70px;
  margin-left: 100px;
  border: 1px solid #ccc;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>